<template>
  <div>
    <CAlert 
      v-for="(warning, index) in warnings" 
      :key="index" 
      color="info" 
      class="warning-margin">
      <strong>WARNING:</strong> {{ warning.text }}
      <CButton 
        color="info"
        size="sm"
        c:if="warning.location"
        @click="goTo(warning.location)">Open</CButton>
    </CAlert>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Warning',
  computed: mapState({
    warnings: state => state.warnings
  }),
  methods: {
    goTo(location) {
      this.$router.replace({ path: location })
    }
  }
}
</script>

<style>
  .warning-margin {
    margin: 12px 30px 0 30px;
  }
</style>
